// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1SScm","header":"MessagesList_header__35_--","chat":"MessagesList_chat__1RmZ7"};